module.exports = __webpack_public_path__ + "img/0Q3B8639-42_H_Black_MockedUp.37203c13.jpg";